import type {
  CreateStaffRequest,
  CreatedStaff,
  StaffPasswordReset,
  StaffSummary,
  UpdateStaffRequest,
} from "@csbi/contracts"
import { get, patch, post } from "../../shared/api/request.js"

export const fetchStaff = (signal?: AbortSignal) => get<StaffSummary[]>("/staff", signal)

export const createStaff = (body: CreateStaffRequest) => post<CreatedStaff>("/staff", body)

export const updateStaff = (staffId: string, body: UpdateStaffRequest) =>
  patch<StaffSummary>(`/staff/${staffId}`, body)

export const resetStaffPassword = (staffId: string) =>
  post<StaffPasswordReset>(`/staff/${staffId}/password`, {})
